export default () => {
    const videoEls = document.getElementsByClassName('js-video-fallback');

    Array.from(videoEls).forEach(el => {
        const playPromise = el.play();

        if(typeof playPromise !== 'undefined') {
            // eslint-disable-next-line
            playPromise.catch(() => {
                // Autoplay was prevented.
                if(el.hasAttribute('data-fallback')) {
                    const parent = el.parentElement;
                    const fallbackImage = el.getAttribute('data-fallback');
                    const img = new Image();

                    img.src = fallbackImage;
                    parent.appendChild(img);
                    el.remove();
                }
            })
        }
    });

}